angular.module("vouchers").classy.controller({
    name: "VouchersModalController",
    inject: ["$scope", "$modalInstance", "SchoolModelService", "VouchersModelService", "item"],
    init: function() {
        this.$.$modalInstance = this.$modalInstance;
        this.$.SchoolModelService = this.SchoolModelService;

        this.$.items = [];
        this.$.SchoolModelService.get();
        if (typeof this.item === "undefined") {
            this.$.newVoucher = true;
            this.$.add();
        } else {
            this.$.newVoucher = false;
            this.$.items.push(this.item);
        }
    },
    add: function() {
        let index = this.VouchersModelService.new();
        this.VouchersModelService.data[index].memo = "FAST Voucher";
        this.$.items.push(this.VouchersModelService.data[index]);
    },
    remove: function(index) {
        this.$.items.splice(index, 1);
    },
    startSaveProcess: function(scope, instance) {
        instance.options.factor = .3;
        if (this.$.newVoucher) {
            return this.VouchersModelService
                .putMultiple(this.$.SchoolModelService.data[0].schoolID, this.$.items, instance)
                .then((result) => {
                    this.VouchersModelService.origData = result.data;
                    this.VouchersModelService.data = result.data;
                    this.$.SchoolModelService.data[0].Free_Vouchers = this.calcFreeVouchers();
                    this.$modalInstance.close();
                });
        } else {
            return this.VouchersModelService.put(this.$.SchoolModelService.data[0].schoolID, this.item, instance)
                .then(() => {
                    this.VouchersModelService.resolveData();
                    this.$.SchoolModelService.data[0].Free_Vouchers = this.calcFreeVouchers();
                    this.$modalInstance.close();
                });
        }
    },
    calcFreeVouchers: function() {
        let freeVouch = this.$.SchoolModelService.data[0].Free_Vouchers;
        for (let i = 0; i < this.$.items.length; i++) {
            if (this.$.items[i].free == 1) {
                freeVouch--;
            }
        }
        return freeVouch;
    }
});
